import React from 'react';

export const SponsorListConfig = {
    settings: {
        layout: {
            config: {
                header: { display: true },
                footer: { display: true },
                navbar: { display: true },
            },
        },
    },
    isPrivate: true,
    eventName: 'exhibition_hall',
    routes: [
        {
            path: '/:organizationId/:eventSlug/sponsors',
            component: React.lazy(() => import('./SponsorList')),
        },
    ],
};
